import React, { useEffect, useCallback, useState} from 'react';
import {DOT, DASH, VARIABLE} from 'effects/midi/tidal/types.js';
import {getLeafString, dash, dot} from 'effects/midi/tidal/parser.js';
import {
    applyToLeaf,
    applyRule,
    before,
    REGULAR,
    after,
    when ,
    otherwise,
    ACCENT,
    FLAM,
    STACCATO,
    DOUBLE,
    REST,
    LEGATO,
    PIANO,
    PIANISSIMO
} from 'effects/midi/scripting/trules.js';
import CellInner from './CellInner.js';
import {connect} from 'react-redux';

const MORE_OPTIONS = [REST, PIANISSIMO, PIANO, REGULAR, DOUBLE, FLAM];

var HELP = {};
HELP[DOT]="Dot";
HELP[DASH]="Dash";
HELP[ACCENT.type]= "Accent";
HELP[STACCATO.type]= "Staccato";
HELP[LEGATO.type]= "Legato";
HELP[PIANO.type]= "Piano (soft)";
HELP[REGULAR.type]= "Default strength";
HELP[PIANISSIMO.type]= "Pianissimo (softest)";
HELP[REST.type]= "Rest (doesnt play)";
HELP[DOUBLE.type]= "Double (play faster)";
HELP[FLAM.type]= "2 notes almost at the same time";

const GridToolbar = ({mode, setMode}) => { 
   
    let [showOptions, setShowOptions] = useState(false);

    useEffect(() => {
        if (!MORE_OPTIONS.includes(mode)) {
            setShowOptions(false);
        }
    }, [mode, setShowOptions]);
    return (
        <div onMouseDown={(e) => e.stopPropagation()} className="grid-toolbar">
          <Option option={DOT} mode={mode} setMode={setMode}/>
          <Option option={DASH} mode={mode} setMode={setMode}/>
          <Option option={ACCENT} mode={mode} setMode={setMode}/>
          <Option option={STACCATO} mode={mode} setMode={setMode}/>
          <Option option={LEGATO} mode={mode} setMode={setMode}/>
          <div onClick={() => setShowOptions(!showOptions)} className={showOptions ? "show more-options" : "more-options"}>
            {MORE_OPTIONS.includes(mode) ?
             <Option noTooltip={true} option={mode} mode={mode} setMode={setMode}/> : '...'}
          {showOptions && <div className="options-overlay">
                            <Option option={REST} mode={mode} setMode={setMode}/>
                            <Option option={PIANISSIMO} mode={mode} setMode={setMode}/>
                            <Option option={PIANO} mode={mode} setMode={setMode}/>
                            <Option option={REGULAR} mode={mode} setMode={setMode}/>
                            <Option option={DOUBLE} mode={mode} setMode={setMode}/>
                            <Option option={FLAM} mode={mode} setMode={setMode}/>
                          </div>}
          </div>
        </div>
    );
}

const Option = ({option, mode, setMode, noTooltip}) => {
    let [hover, setHover] = useState(false);
    let className = "option ";
    if (option === mode) {
        className += " selected";
    }

    let text= <CellInner cell={option}/>;
    return (
        <div onMouseOver={() => setHover(true)} onMouseLeave={() => setHover(false)} className={className} onClick={() => setMode(option)}>
          {text}
          {!noTooltip && hover && <div className="option-tooltip">{HELP[option.type || option]}</div>}
        </div>
    );
};

export default GridToolbar;
